/**
 * Ink Symbols (src/assets/ink-symbols.css): draws the characters a page's font
 * lacks, the same on every device. It goes after the page's fonts in every
 * stack that shows document text, and before the generic family.
 */
export const SYMBOL_FALLBACK = "'Ink Symbols'"

export const APP_FONTS: readonly string[] = [
  'Besley',
  'BioRhyme',
  'Coustard',
  'Courier Prime',
  'Cutive',
  'Epilogue',
  'IBM Plex Mono',
  'IBM Plex Sans',
  'Maple',
  'Recursive',
  'RecVar',
  'Sentient',
  'Solway',
  'Source Code Pro',
] as const

export interface FontCapabilities {
  bold: boolean
  italic: boolean
  weights: readonly number[]
  variableWeightRange: { min: number; max: number } | null
}

/** Native faces declared in style.css. Keep this beside APP_FONTS so the
 * bundled-font picker and formatting controls share one source of truth. */
export const APP_FONT_CAPABILITIES: Readonly<Record<string, FontCapabilities>> = {
  Besley: { bold: true, italic: true, weights: [], variableWeightRange: { min: 400, max: 900 } },
  BioRhyme: { bold: true, italic: false, weights: [], variableWeightRange: { min: 200, max: 800 } },
  Coustard: { bold: true, italic: false, weights: [400, 900], variableWeightRange: null },
  'Courier Prime': { bold: true, italic: true, weights: [400, 700], variableWeightRange: null },
  Cutive: { bold: false, italic: false, weights: [400], variableWeightRange: null },
  Epilogue: { bold: true, italic: true, weights: [], variableWeightRange: { min: 100, max: 900 } },
  'IBM Plex Mono': { bold: true, italic: true, weights: [100, 200, 300, 400, 500, 600, 700], variableWeightRange: null },
  'IBM Plex Sans': { bold: true, italic: false, weights: [], variableWeightRange: { min: 100, max: 700 } },
  Maple: { bold: true, italic: true, weights: [], variableWeightRange: { min: 100, max: 800 } },
  Recursive: { bold: true, italic: false, weights: [], variableWeightRange: { min: 300, max: 1000 } },
  RecVar: { bold: true, italic: true, weights: [], variableWeightRange: { min: 300, max: 1000 } },
  Sentient: { bold: true, italic: true, weights: [], variableWeightRange: { min: 200, max: 700 } },
  Solway: { bold: true, italic: false, weights: [300, 400, 500, 700, 800], variableWeightRange: null },
  'Source Code Pro': { bold: true, italic: true, weights: [], variableWeightRange: { min: 200, max: 900 } },
}
